import axios from 'axios'

export enum ERROR_MESSAGES {
  unauthorized = 'unauthorized',
  server_error = 'server error',
  unknown = 'unknown',
}

export const errorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    switch (error.response?.status) {
      case 401:
        return ERROR_MESSAGES.unauthorized
      case 500:
        return ERROR_MESSAGES.server_error
      default:
        return error.response?.data?.message || ERROR_MESSAGES.unknown
    }
  }

  return error instanceof Error ? error.message : ERROR_MESSAGES.unknown
}
